import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import React from 'react'
import {RESERVATION_ERROR, SEATING_ERROR} from '../../../../constants'
import {PlaceCapacityReached} from './place-capacity-reached'
import {ReservationFailed} from './reservation-failed'
import {SeatsUnavailable} from './seats-unavailable'
import {SomethingWentWrong} from './something-went-wrong'
import {TicketLimitReached} from './ticket-limit-reached'
import {TicketUnavailable} from './ticket-unavailable'

export const ErrorModal = ({
  seatingError,
  reservationError,
}: {
  seatingError: SEATING_ERROR
  reservationError: RESERVATION_ERROR
}) => {
  const {experiments} = useExperiments()

  const ticketUnavailable =
    reservationError === RESERVATION_ERROR.TICKET_DEFINITION_HIDDEN ||
    reservationError === RESERVATION_ERROR.TICKET_DEFINITION_NOT_FOUND ||
    reservationError === RESERVATION_ERROR.TICKETS_UNAVAILABLE

  if (reservationError === RESERVATION_ERROR.PLACE_RESERVED) {
    return <SeatsUnavailable />
  } else if (experiments.enabled(ExperimentNames.SeatingTicketUnavailableModal) && ticketUnavailable) {
    return <TicketUnavailable />
  } else if (reservationError === RESERVATION_ERROR.SOMETHING_WENT_WRONG) {
    return <SomethingWentWrong />
  } else if (seatingError === SEATING_ERROR.TICKET_LIMIT_REACHED) {
    return <TicketLimitReached />
  } else if (seatingError === SEATING_ERROR.PLACE_CAPACITY_REACHED) {
    return <PlaceCapacityReached />
  } else if (experiments.enabled(ExperimentNames.SeatingTicketUnavailableModal) && !!reservationError) {
    return <ReservationFailed />
  }
  return null
}
